import Styles from './MobileSelectImage.module.scss'
import { getMediaFiles } from 'components/Design/UploadsTab/getMediaFiles'
import { useUploads } from 'components/Design/UploadsTab/useUploads'
import { SelectedImage } from 'types'
import { collectResults } from 'utils/query'
import { useImagePickerContext } from 'components/ImagePickerModal/ImagePickerContext'
import { Button } from 'blaze-ui/Button'
import { Grid } from 'blaze-ui/icons'
import { Checkbox } from 'components/Form/Checkbox/Checkbox'
import { DragOverlayForFirstUpload } from 'components/Design/UploadsTab/DragOverlay'
import { ShimmeringColor } from 'components/BrandWizardVisualAnalysisModal/LoadingState'
import { useEffect, useState } from 'react'
import cx from 'classnames'

interface Props {
  onMoreClick?: () => void
}

export const LibraryImages = ({ onMoreClick }: Props) => {
  const imagePickerContext = useImagePickerContext()
  const [resetImage, setResetImage] = useState(false)
  const { selectedImages, toggleSelectedImage, accept } = imagePickerContext
  const uploadsQuery = useUploads()
  const uploads = collectResults(uploadsQuery, (data) => data.files)
  const mediaFiles = getMediaFiles(uploads, accept)
  const images: SelectedImage[] = mediaFiles.map((mf) => ({ ...mf, url: mf.thumbnail_url as string })).slice(0, 4)

  useEffect(() => {
    if (images.length > 0 && !resetImage) {
      setResetImage(true)
      toggleSelectedImage(images[0])
    }
  }, [uploadsQuery.isFetched]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {uploadsQuery.isLoading ? (
        <div className={Styles.imagesSection}>
          <div className={Styles.selectedImage}>
            <ShimmeringColor aspectRatio={1} />
          </div>
          <div className={Styles.imagesGrid}>
            {Array.from(Array(4)).map((_, i) => (
              <div key={`loading-${i}`} className={Styles.image}>
                <ShimmeringColor aspectRatio={1} />
              </div>
            ))}
          </div>
        </div>
      ) : (
        <>
          {images.length > 0 ? (
            <div className={Styles.imagesSection}>
              <img
                className={Styles.selectedImage}
                src={selectedImages[0]?.source_url || selectedImages[0]?.url || images[0]?.source_url}
                alt="library"
              />
              <div className={Styles.imagesGrid}>
                {images.map((file) => (
                  <div
                    key={file.id}
                    className={cx(Styles.image, { [Styles.isSelected]: file.id === selectedImages[0]?.id })}
                    onClick={() => toggleSelectedImage(file)}
                  >
                    <img src={file.source_url} alt="img" />
                    {file.id === selectedImages[0]?.id && (
                      <>
                        <div className={Styles.checkbox}>
                          <Checkbox size="lg" isSelected />
                        </div>
                      </>
                    )}
                  </div>
                ))}
              </div>
              <Button frontIcon={Grid} fullWidth variant="secondary" size="lg" onPress={onMoreClick}>
                Select another from my Image Library
              </Button>
            </div>
          ) : (
            <DragOverlayForFirstUpload
              style={{ aspectRatio: 1, width: '100%', margin: 0 }}
              withSupportedFilesTag={false}
              withDropFilesTag={false}
              buttonProps={{ label: 'Uploads Files' }}
            />
          )}
        </>
      )}
    </>
  )
}
